import { AppState } from "../../../../redux-configuration/AppState";

export const isLoadingSendingChatMessageSelector = (appState: AppState): boolean => appState.messaging.message.send.loading
export const errorSendingChatMessageSelector = (appState: AppState): string | undefined => appState.messaging.message.send.error
export const successSendingChatMessageSelector = (appState: AppState): boolean | null => appState.messaging.message.send.success
